import { createAction } from '@reduxjs/toolkit';
import { createAsyncAction } from 'stores/helpers';
import { ModelJson } from '../api/fetch-model.types';

export const fetchModel = createAsyncAction<undefined, ModelJson | null, Error | null, undefined>(
  'pageModel/fetchModel'
);
export const fetchModelReset = createAction('pageModel/fetchModel/reset');
